import { ManageJobMarketSettingsTranslation } from 'locales/de/pages/Jobmarket/manageJobmarketSettings';

const en: ManageJobMarketSettingsTranslation = {
  title: 'Jobmarket settings',
  prices: 'Prices',
  categories: 'Categories',
  duration: 'Duration',
  factor: 'Factor',
  price: 'Price',
  factors: {
    year: 'Year',
    month: 'Month',
    week: 'Week',
    day: 'Day'
  },
  paid: 'With costs',
  notPaid: 'Free',
  alerts: {
    saveTypeSuccessful: 'The category was successfully saved.',
    saveTypeFailed: 'The category could not be saved.',
    savePriceSuccessful: 'The price was successfully saved.',
    savePriceFailed: 'The price could not be saved.',
    errorLoading: 'Could not load jobmarket settings.'
  },
  cancelConfirm: {
    message: 'Do you really want to cancel? Changes will be lost.'
  }
};
export default en;
